import { Flex } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { CourseReviewContext } from "./CourseReview";
import CourseReviewList from "./CourseReviewList/CourseReviewList";

const PENDING = "pending";
const IN_PROGRESS = "in progress";
const PUBLISHED = "published";

const CourseReviewHome = () => {
  const { t } = useTranslation();
  const { reviews } = useContext(CourseReviewContext);
  const pendingReviews = reviews.filter((r) => r.upcoming);
  const inProgressReviews = reviews.filter(
    (r) => !r.upcoming && !r.shareable_code
  );
  const publishedReviews = reviews.filter(
    (r) => !r.upcoming && r.shareable_code
  );

  return (
    <Flex wrap="wrap" gap="large">
      <Flex.Item width="100%">
        <CourseReviewList
          reviews={pendingReviews}
          status={PENDING}
          title={t("courseReview.pendingCourseReviews")}
          alertMessage={t("courseReview.noPendingReviews")}
        />
      </Flex.Item>
      <Flex.Item width="100%">
        <CourseReviewList
          reviews={inProgressReviews}
          status={IN_PROGRESS}
          title={t("courseReview.inProgressCourseReviews")}
          alertMessage={t("courseReview.noInProgressReviews")}
        />
      </Flex.Item>
      <Flex.Item width="100%">
        <CourseReviewList
          reviews={publishedReviews}
          status={PUBLISHED}
          title={t("courseReview.publishedCourseReviews")}
          alertMessage={t("courseReview.noPublishedReviews")}
        />
      </Flex.Item>
    </Flex>
  );
};

export default CourseReviewHome;
